// Frontend mirror of src/utils/leadDays.js — keep the two in step.
//
// WHEN a filing's task appears on somebody's list. Display-only here: the
// task-proposer on the server is what actually decides, so this exists to state
// the rule without asking the backend.
//
// ⚠️ MONTHLY IS NOT A LEAD-DAYS RULE. Every other cadence counts backwards from
// the due date; a monthly filing opens on the FIRST OF THE MONTH IT IS DUE IN,
// because the return covers the month that has just ended — the data does not
// exist until the month turns over. GSTR-1 for February is due 11 March, and
// counting 7 days back put it on somebody's list on 4 March, a week into a
// month whose filings they could already have started.
export const LEAD_DAYS_BY_FREQUENCY = {
  // Still the runway for every OTHER frequency. Monthly's entry is only a
  // rough fallback now — the proposer does not use it.
  monthly: 7,
  quarterly: 14,
  half_yearly: 21,
  annual: 30,
  one_time: 7,
};

export const DEFAULT_LEAD_DAYS = 7;

export const leadDaysForFrequency = (frequency) =>
  LEAD_DAYS_BY_FREQUENCY[frequency] ?? DEFAULT_LEAD_DAYS;

// The instant a filing becomes proposable. Mirrors the server exactly.
export function proposalOpensAt(dueDate, frequency) {
  const due = new Date(dueDate);
  if (frequency === 'monthly') {
    // The 1st of the month the filing is DUE in — not the month it covers.
    return new Date(due.getFullYear(), due.getMonth(), 1, 0, 0, 0, 0);
  }
  return new Date(due.getTime() - leadDaysForFrequency(frequency) * 86400000);
}

export const isProposalWindowOpen = (dueDate, frequency, now = new Date()) =>
  new Date(now) >= proposalOpensAt(dueDate, frequency);

// How to say it on screen. "Opens N days before due" is simply untrue for a
// monthly head now, so the sentence comes from here rather than being built at
// the call site.
export const describeProposalWindow = (frequency) => (frequency === 'monthly'
  ? 'Task opens on the 1st of the due month'
  : `Task opens ${leadDaysForFrequency(frequency)} days before due`);
